import { Component, OnInit } from '@angular/core';
import { ICustomApp, ILogin } from '@sv/interfaces';
import { CustomAppService } from 'src/app/_services/_content/customApp.service';

@Component({
  selector: 'app-dvgw-error-page-login',
  templateUrl: './dvgw-error-page-login.component.html',
  styleUrls: ['./dvgw-error-page-login.component.scss']
})
export class DvgwErrorPageLoginComponent implements OnInit {
  constructor(private mainService: CustomAppService) {}
  customApp: ICustomApp;
  login: ILogin;
  ngOnInit(): void {
    this.mainService.getCustomAppListener().subscribe((customApp) => {
      this.customApp = customApp;
      this.login = this.customApp.login as ILogin;
    });
  }
}
